import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  boldSpan: {
    fontWeight: 600,
  },
  gridItem: {
    alignSelf: 'center',
  },
  cannotWithdrawMessage: {
    fontSize: 12,
    marginBottom: 10,
    color: theme.palette.action.disabled,
  },
  disabledWithdrawText: {
    color: theme.palette.action.disabled,
  },
}));
